/**
 * File Slice — Types & Initial State
 *
 * Matches Smithy model: FintechLastMileBeaconSmithyModel/model/fetch-files.smithy
 * API: POST /files/fetch (1–100 file names per call, server-side pagination)
 */
import { ExecutionResponse } from 'src/store/slices/execution/executionState';

/** Response from POST /files/fetch. */
export interface FetchFilesResponse {
  executions: ExecutionResponse[];
  notFound: string[];
  totalPages: number;
}

/** Redux slice state. */
export interface FileState {
  data: FetchFilesResponse | null;
  loading: boolean;
  error: string | null;
  currentRequestId: string | undefined;
}

export const fileInitialState: FileState = {
  data: null,
  loading: false,
  error: null,
  currentRequestId: undefined,
};
